import React from 'react';
import PropTypes from 'prop-types';
import { LBContainer, LBItem } from './TourPlayOptionsDialog.ListBox.Styled';


function ListBox(props, ref) {

    const {
        items,
        selectedItemId,
        setSelectedItemId,
    } = props;


    const itemElements = items.map(item => {

        return (
            <LBItem
                key={item.id}
                selected={item.id === selectedItemId}
                onClick={() => setSelectedItemId(item.id)}
            >
                {item.label}
            </LBItem>);
    });


    return (<LBContainer>
            {itemElements}
        </LBContainer>
    );
}


ListBox.propTypes = {
    items:PropTypes.array.isRequired,
    selectedItemId:PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    setSelectedItemId:PropTypes.func.isRequired,
}


export default ListBox;